import update from 'immutability-helper';
import { createReducer } from 'redux-create-reducer';
import actionsAndConstants from '../../../shared/actionsAndConstants';

const {
  loginPage: { constants: loginPageConstants },
  topNavbar: { constants: topNavbarConstants }
} = actionsAndConstants;

const initialState = {
  depotId: null,
  isLoggedIn: false,
  isLoggingOut: false,
  name: '',
  role: {},
  username: ''
};

const loginSucceeded = (state, { payload: user }) => (
  update(state, { $merge: { ...user, isLoggedIn: true } })
);

const logout = state => (
  update(state, { isLoggingOut: { $set: true } })
);

const logoutSucceeded = () => initialState;

const userReducer = createReducer(initialState, {
  [loginPageConstants.loginSucceeded]: loginSucceeded,
  [topNavbarConstants.logout]: logout,
  [topNavbarConstants.logoutSucceeded]: logoutSucceeded,
});

export default userReducer;



// WEBPACK FOOTER //
// ./src/containers/Root/reducer/user.js